import { USER_AUTH, USER_LOGOUT, SESSION_IS_VALID, LOCATION_GET_BY_USER, ACCOUNT_GET_BY_USER, LOCATION_GET_THEME, LOCATION_SET_THEME, TEMPLATE_GET_ACTIVE, LOCATION_GET_STATS, PRINTER_GET_ALL, PRINTER_DELETE, PRINTER_ACTIVATE, PRINTER_DEACTIVATE, PRINTER_SET_DEFAULT, PRINTER_CREATE, PRINTER_UPDATE, PRINTER_CLEAR_ACTIVE, TEMPLATE_ACTIVATE, TEMPLATE_DEACTIVATE, TEMPLATE_GET_ALL, TEMPLATE_GET_ALL_V2, TEMPLATE_UPDATE, TEMPLATE_GET_V2, TEMPLATE_CREATE, TEMPLATE_DELETE, TEMPLATE_COPY } from "../redux/serverEndpoints";
import { Memory } from "./Memory";
import { User, UserType } from "./User";
import * as Utility from '../shared/utility';
import { UserProfile } from "./UserProfile";
export class UserSession {
    constructor(date_started = new Date(), date_expires = new Date(), token = null, is_onboarded = false, first_name = null, last_name = null, session_id = null, user_guid = null, email = null, is_profile_complete = false, user_type = UserType.Worker, account_id = null, location_id = null, permissions = null) {
        this.date_started = date_started;
        this.date_expires = date_expires;
        this.token = token;
        this.is_onboarded = is_onboarded;
        this.first_name = first_name;
        this.last_name = last_name;
        this.session_id = session_id;
        this.user_guid = user_guid;
        this.email = email;
        this.is_profile_complete = is_profile_complete;
        this.user_type = user_type;
        this.account_id = account_id;
        this.location_id = location_id;
        this.permissions = permissions;
    }
    static get() {
        let session = null;
        var data = Memory.getString(this._key);
        if (data) {
            var parsed = JSON.parse(window.atob(data));
            var sess = new UserSession();
            Object.assign(sess, parsed);
            session = sess;
        }
        return session;
    }
    static override(token) {
        Memory.saveObject(UserSession._key, token);
        this.clearCache();
    }
    static clearCache() {
        this._user = null;
        this._profile = null;
    }
    static update(fieldsToUpdate) {
        let session = this.get();
        if (session === null)
            session = new UserSession();
        let copy = JSON.parse(JSON.stringify(session));
        for (var prop in fieldsToUpdate) {
            session[prop] = fieldsToUpdate[prop];
        }
        var serialized = JSON.stringify(session);
        var token = btoa(serialized);
        // console.log("Saving Session", session, copy);
        Memory.saveObject(this._key, token);
    }
    static getUser(onSuccess) {
        if (this._user === null) {
            if (this.isValid()) {
                this._user = new User();
                this._user.load(this.get().user_guid, onSuccess);
            }
        }
        else {
            onSuccess(this._user);
        }
    }
    static getUserProfile(onSuccess) {
        if (this._profile === null) {
            if (this.isValid()) {
                this._profile = new UserProfile();
                this._profile.loadByUser(this.get().user_guid, onSuccess);
            }
        }
        else {
            onSuccess(this._profile);
        }
    }
    static isValid() {
        return this.get() != null && !this.get().isExpired();
    }
    isExpired() {
        return this.date_expires < new Date();
    }
    hasLocation() {
        return this.location_id != null;
    }
    hasAccount() {
        return this.account_id != null;
    }
    static validateCurrent(onValid, onInvalid) {
        if (this.isValid()) {
            Utility.httpRequest(SESSION_IS_VALID.url, SESSION_IS_VALID.data, {})
                .then(resp => {
                //console.log("Full response", resp);           
                //console.log("Part response", resp.data?.Data);           
                if (resp.data.Data && onValid != null) {
                    onValid();
                }
                else if (onInvalid != null) {
                    onInvalid();
                }
            }).catch(_ => {
                if (onInvalid != null)
                    onInvalid();
            });
        }
    }
    static abandon() {
        if (this.get() != null) {
            //Async request to server to clear session on CMS and Payment svc            
            Memory.deleteObject(this._key);
            Memory.clear();
            UserSession.logout();
        }
        this.clearCache();
    }
    static logout() {
        Utility.httpRequest(USER_LOGOUT.url, USER_LOGOUT.data, {})
            .then(_ => {
            console.log("Successfully logged out");
            //this.override(token);
        }).catch((error) => {
            console.error("Error logging out", error);
        });
    }
    static authenticate(email, password, onSuccess = null, onFailure = null, setIsLoading = null) {
        if (setIsLoading === null)
            setIsLoading = (load) => { console.log("Is Loading:", load); };
        var failure = (error) => {
            UserSession.abandon();
            // console.log("Authentication error", error);
            // if (error?.response?.data?.title === 'UserExistsButNotVerifiedException' ){
            //     errMsg = 'This user has not been verified';
            //     Utility.notifyWarning(errMsg);
            //     setIsLoading(false);
            // }else if (error?.response?.data?.title === 'UserNotFoundException' ) {
            //     errMsg = 'Email or password incorrect'
            //     Utility.notifyWarning(errMsg);
            //     setIsLoading(false);
            // } else {
            //     errMsg = Utility.errorLog(error, false, true);
            // }
            setIsLoading(false);
            if (onFailure != null)
                onFailure(error);
        };
        Utility.httpRequest(USER_AUTH.url, USER_AUTH.data, { "email": email, "password": password })
            .then(response => {
            var data = response.data;
            if (data.IsValid) {
                var token = data.Data;
                var str = JSON.stringify(token);
                UserSession.override(btoa(str));
                //this.override(token);
                if (onSuccess != null)
                    onSuccess(UserSession.get());
            }
            else {
                console.log("Error here", data);
                failure(data);
            }
        }).catch(failure);
    }
    static activateTemplate(templateID, version, onSuccess, onFailure) {
        var _a, _b;
        Utility.httpRequest(TEMPLATE_ACTIVATE.url, TEMPLATE_ACTIVATE.data, { templateID: templateID, accountID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.account_id, locationID: (_b = this.get()) === null || _b === void 0 ? void 0 : _b.location_id, Version: version })
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static copyTemplate(templateID, onSuccess, onFailure) {
        var _a, _b;
        var url = TEMPLATE_COPY(templateID);
        Utility.httpRequest(url.url, url.data, { templateID: templateID, accountID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.account_id, locationID: (_b = this.get()) === null || _b === void 0 ? void 0 : _b.location_id })
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static deleteTemplate(templateID, version, onSuccess, onFailure) {
        var _a, _b;
        var url = TEMPLATE_DELETE(templateID);
        Utility.httpRequest(url.url, url.data, { templateID: templateID, accountID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.account_id, locationID: (_b = this.get()) === null || _b === void 0 ? void 0 : _b.location_id, Version: version })
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static deactivateTemplate(templateID, version, onSuccess, onFailure) {
        var _a, _b;
        Utility.httpRequest(TEMPLATE_DEACTIVATE.url, TEMPLATE_DEACTIVATE.data, { templateID: templateID, accountID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.account_id, locationID: (_b = this.get()) === null || _b === void 0 ? void 0 : _b.location_id, Version: version })
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static activatePrinter(printerID, onSuccess, onFailure) {
        var _a;
        Utility.httpRequest(PRINTER_ACTIVATE.url, PRINTER_ACTIVATE.data, { printerID: printerID, locationID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.location_id })
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static deactivatePrinter(printerID, onSuccess, onFailure) {
        var _a;
        Utility.httpRequest(PRINTER_DEACTIVATE.url, PRINTER_DEACTIVATE.data, { printerID: printerID, locationID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.location_id })
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static deletePrinter(printerID, onSuccess, onFailure) {
        var _a;
        var url = PRINTER_DELETE(printerID);
        Utility.httpRequest(url.url, url.data, { printerID: printerID, locationID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.location_id })
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static setDefaultLocationPrinter(printerID, onSuccess, onFailure) {
        var _a;
        Utility.httpRequest(PRINTER_SET_DEFAULT.url, PRINTER_SET_DEFAULT.data, { printerID: printerID, locationID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.location_id })
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static createPrinter(printer, onSuccess, onFailure) {
        var _a, _b;
        var obj = {
            locationID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.location_id,
            accountID: (_b = this.get()) === null || _b === void 0 ? void 0 : _b.account_id,
        };
        Object.assign(obj, printer);
        Utility.httpRequest(PRINTER_CREATE.url, PRINTER_CREATE.data, obj)
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static updatePrinter(printer, onSuccess, onFailure) {
        var _a, _b;
        var obj = {
            locationID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.location_id,
            accountID: (_b = this.get()) === null || _b === void 0 ? void 0 : _b.account_id,
        };
        Object.assign(obj, printer);
        var url = PRINTER_UPDATE(obj["GUID"]);
        Utility.httpRequest(url.url, url.data, obj)
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static createTemplate(template, onSuccess, onFailure) {
        var _a;
        var obj = {
            //locationID: this.get()?.location_id, 
            accountID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.account_id,
        };
        Object.assign(obj, template);
        console.log("OBJ", obj, template);
        Utility.httpRequest(TEMPLATE_CREATE.url, TEMPLATE_CREATE.data, obj)
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static updateTemplate(template, onSuccess, onFailure) {
        var _a;
        var obj = {
            //locationID: this.get()?.location_id, 
            accountID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.account_id,
        };
        Object.assign(obj, template);
        var url = TEMPLATE_UPDATE(obj["GUID"]);
        Utility.httpRequest(url.url, url.data, obj)
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static getLocations(acct, onSuccess) {
        Utility.httpRequest(LOCATION_GET_BY_USER.url, LOCATION_GET_BY_USER.data, { accountID: acct })
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
        }).catch(e => {
            alert("Unable to load locations");
            console.error(e);
        });
    }
    static getAccounts(onSuccess) {
        Utility.httpRequest(ACCOUNT_GET_BY_USER.url, ACCOUNT_GET_BY_USER.data, {})
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
        }).catch(e => {
            alert("Unable to load accounts");
            console.error(e);
        });
    }
    static getTheme(onSuccess) {
        var _a;
        var data = {
            locationID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.location_id
        };
        Utility.httpRequest(LOCATION_GET_THEME.url, LOCATION_GET_THEME.data, data)
            .then(resp => {
            //console.log("DATA", resp);         
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
        }).catch(e => {
            alert("Unable to load theme");
            console.error(e);
        });
    }
    static setTheme(theme, onSuccess, onFailure) {
        var _a;
        theme.locationID = (_a = UserSession.get()) === null || _a === void 0 ? void 0 : _a.location_id;
        Utility.httpRequest(LOCATION_SET_THEME.url, LOCATION_SET_THEME.data, theme)
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
            else {
                onFailure(resp.data);
            }
        }).catch(e => {
            console.error(e);
            onFailure(e);
        });
    }
    static getAllTemplates(onSuccess) {
        var _a, _b;
        var data = {
            accountID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.account_id,
            locationID: (_b = this.get()) === null || _b === void 0 ? void 0 : _b.location_id
        };
        Utility.httpRequest(TEMPLATE_GET_ALL.url, TEMPLATE_GET_ALL.data, data)
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
        }).catch(e => {
            alert("Unable to load templates");
            console.error(e);
        });
    }
    static getAllTemplatesV2(onSuccess) {
        var _a, _b;
        var data = {
            accountID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.account_id,
            locationID: (_b = this.get()) === null || _b === void 0 ? void 0 : _b.location_id,
            noData: true
        };
        Utility.httpRequest(TEMPLATE_GET_ALL_V2.url, TEMPLATE_GET_ALL_V2.data, data)
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
        }).catch(e => {
            alert("Unable to load templates");
            console.error(e);
        });
    }
    static getTemplateV2(guid, onSuccess) {
        var _a, _b;
        var data = {
            accountID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.account_id,
            locationID: (_b = this.get()) === null || _b === void 0 ? void 0 : _b.location_id,
            guid: guid
        };
        Utility.httpRequest(TEMPLATE_GET_V2.url, TEMPLATE_GET_V2.data, data)
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
        }).catch(e => {
            alert("Unable to load templates");
            console.error(e);
        });
    }
    static getActiveTemplates(onSuccess) {
        var _a, _b;
        var data = {
            accountID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.account_id,
            locationID: (_b = this.get()) === null || _b === void 0 ? void 0 : _b.location_id
        };
        Utility.httpRequest(TEMPLATE_GET_ACTIVE.url, TEMPLATE_GET_ACTIVE.data, data)
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
        }).catch(e => {
            alert("Unable to load templates");
            console.error(e);
        });
    }
    // static getActivePrinters(onSuccess) {
    //     var data = {
    //         locationID: this.get()?.location_id
    //     };
    //     Utility.httpRequest(PRINTER_GET_ACTIVE.url, PRINTER_GET_ACTIVE.data, data)
    //         .then(resp => {            
    //             if(resp.data.IsValid && onSuccess) {
    //                 onSuccess(resp.data);
    //             }
    //         }
    //         ).catch(e => {
    //             alert("Unable to load templates");
    //             console.error(e);
    //         });
    // }
    static getAllPrinters(onSuccess) {
        var _a;
        var data = {
            locationID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.location_id,
            activeOnly: false
        };
        Utility.httpRequest(PRINTER_GET_ALL.url, PRINTER_GET_ALL.data, data)
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
        }).catch(e => {
            alert("Unable to load printers");
            console.error(e);
        });
    }
    getStats(startDate, endDate, onSuccess) {
        const endpoint = LOCATION_GET_STATS(this.location_id);
        Utility.httpRequest(endpoint.url, endpoint.data, { locationID: this.location_id, startDate: startDate, endDate: endDate })
            .then((res) => {
            var resp = res.data;
            if (resp.IsValid) {
                if (onSuccess !== null && typeof onSuccess == "function") {
                    onSuccess(resp);
                }
            }
        })
            .catch((error) => {
            console.log('[Location stats error]', error);
            Utility.errorLog(error);
            Utility.notifyError(error.response.data.details);
            // return;
        });
    }
    static cancelActivePrints(onSuccess) {
        var _a;
        var data = {
            locationID: (_a = this.get()) === null || _a === void 0 ? void 0 : _a.location_id
        };
        Utility.httpRequest(PRINTER_CLEAR_ACTIVE.url, PRINTER_CLEAR_ACTIVE.data, data)
            .then(resp => {
            if (resp.data.IsValid && onSuccess) {
                onSuccess(resp.data);
            }
        }).catch(e => {
            alert("Unable to clear print queue");
            console.error(e);
        });
    }
}
UserSession._user = null;
UserSession._profile = null;
UserSession._key = "token";
//# sourceMappingURL=UserSession.js.map